import { createFileRoute } from "@tanstack/react-router";
import { WaitingScreen } from "@modules/applications/views";
import { requireAnySurface } from "./-guards";

/**
 * /staff/rounds/$roundId/waiting — "Dossiers en attente", one of the round-context rail's three
 * tabs. See `staff.rounds_.$roundId.applications.tsx` for why the segment is `rounds_`.
 *
 * Gated on EITHER staff surface (2026-09-13) — same reasoning as the queue and applications list.
 */
export const Route = createFileRoute("/staff/rounds_/$roundId/waiting")({
  beforeLoad: ({ context, location }) =>
    requireAnySurface(
      context.queryClient,
      ["round_configuration", "intake_operations"],
      location.pathname
    ),
  staticData: {
    breadcrumb: ["nav.rounds", "breadcrumb.all-rounds", "breadcrumb.waiting"],
  },
  component: RoundWaitingRoute,
});

function RoundWaitingRoute() {
  const { roundId } = Route.useParams();
  return <WaitingScreen roundId={roundId} />;
}
